import { AssetsDocumentsPart } from '@/shared/lib/sj-orm/models/asset.dto';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { CollectionName } from '@/shared/lib/sj-orm/types';

import { TDtoWrapper } from '../../form-wrapper.types';

type Keys = keyof Omit<AssetsDocumentsPart, 'createdAt' | 'updatedAt'>;
type AssetsDocumentsHelpPart = {
  [key in Keys]: QuestionType.PICK_ARRAY_OF_DTO;
};

export type AssetsDocumentsPartType = TDtoWrapper<AssetsDocumentsPart, AssetsDocumentsHelpPart>;

const AssetsDocumentsFormPartFull: AssetsDocumentsPartType = {
  assetAcquisitions: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    items: CollectionName.PRIVATE_DOCUMENTS,
    mode: 'multiple',
    label: 'forms_assets:common.inputs.assetAcquisitions.label',
  },
  sourcesOfAcquisition: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    items: CollectionName.PRIVATE_DOCUMENTS,
    mode: 'multiple',
    label: 'forms_assets:common.inputs.sourcesOfAcquisition.label',
  },
  proofsOfOwnership: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    items: CollectionName.PRIVATE_DOCUMENTS,
    mode: 'multiple',
    label: 'forms_assets:common.inputs.proofsOfOwnership.label',
  },
  paymentMethods: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    items: CollectionName.PRIVATE_DOCUMENTS,
    mode: 'multiple',
    label: 'forms_assets:common.inputs.paymentMethods.label',
  },
  powersOfAttorney: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    items: CollectionName.PRIVATE_DOCUMENTS,
    mode: 'multiple',
    // dtoType: PrivateDocumentCategory.POWERS,
    label: 'forms_assets:common.inputs.powersOfAttorney.label',
    // tooltip: 'forms_assets:common.inputs.powersOfAttorney.tooltip',
    // filter: (doc) =>
    //   (doc as unknown as PrivateDocumentDto).privateCategory === PrivateDocumentCategory.POWERS,
  },
  accessLimitations: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    items: CollectionName.PRIVATE_DOCUMENTS,
    mode: 'multiple',
    label: 'forms_assets:common.inputs.accessLimitations.label',
  },
  assetProtections: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    items: CollectionName.PRIVATE_DOCUMENTS,
    mode: 'multiple',
    label: 'forms_assets:common.inputs.assetProtections.label',
  },
  otherDocuments: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    items: CollectionName.PRIVATE_DOCUMENTS,
    mode: 'multiple',
    // dtoType: PrivateDocumentCategory.OTHER,
    label: 'forms_assets:common.inputs.otherDocuments.label',
  },
};

export const assetsDocumentsBuilder = () =>
  Object.entries(AssetsDocumentsFormPartFull).reduce<AssetsDocumentsPartType>(
    (acc, [key, value]) => {
      const field = key as keyof AssetsDocumentsHelpPart;

      acc[field] = value as AssetsDocumentsPartType[keyof AssetsDocumentsHelpPart];

      return acc;
    },
    {},
  );
